import HomeTargetsSupplier from './HomeTargetsSupplier';

export default HomeTargetsSupplier;
